import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdministrationHeader from "../../components/header-components/AdministrationHeader.jsx";
import ContentPanel from "./panels/ContentPanel.jsx";

/**
 * BoardReportTemplateAdmin - the admin-only template editor (/board-reports/:id/template, gated by
 * AdminRoute in index.js). Editing the block layout/bindings is a template-administration task that
 * applies to EVERY future run, so it lives on its own screen rather than as a tab in the per-report
 * home the whole team uses. Renders the shared ContentPanel with page chrome + a back link to the
 * report home's Settings tab (where the admin "Edit template" link lives).
 */
const BoardReportTemplateAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="h-full flex flex-col bg-background-grey">
      <AdministrationHeader title="Edit template" showPeriodSelector={false} />

      <div className="flex-1 overflow-auto p-8">
        <button
          type="button"
          className="mb-4 text-sm text-text-3 hover:text-text inline-flex items-center gap-1 cursor-pointer"
          onClick={() => navigate(`/board-reports/${id}?tab=settings`)}
        >
          <span aria-hidden="true">←</span> Back to report
        </button>

        <div className="mb-6">
          <h2 className="text-lg font-semibold text-text">Edit template</h2>
          <p className="mt-1 text-sm text-text-2">
            Admin only. Changes to the block layout and bindings apply to every future run of this report.
          </p>
        </div>

        <ContentPanel id={id} />
      </div>
    </div>
  );
};

export default BoardReportTemplateAdmin;
